import React from 'react';
import styled from 'styled-components';

// Top-level navigation, available whether or not a wallet is connected.
// Overview (pitch + live stats) and Contracts (on-chain provenance) are always
// reachable; "My Vault" appears once connected.

const Bar = styled.div`
  grid-column: 1 / -1;
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  margin-top: 1rem;
  flex-wrap: wrap;
`;

const Tab = styled.button`
  background: ${(p) => (p.$active ? 'rgba(255, 215, 0, 0.1)' : 'transparent')};
  color: ${(p) => (p.$active ? '#ffd700' : '#888')};
  border: 1px solid ${(p) => (p.$active ? '#ffd700' : '#333')};
  border-radius: 999px;
  padding: 0.5rem 1.4rem;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover { color: #ffd700; border-color: #ffd700; }
`;

const LandingTabs = ({ view, onChange, connected, showAuctions }) => (
  <Bar>
    {connected && (
      <Tab $active={view === 'vault'} onClick={() => onChange('vault')}>My Vault</Tab>
    )}
    <Tab $active={view === 'overview'} onClick={() => onChange('overview')}>Overview</Tab>
    {showAuctions && (
      <Tab $active={view === 'auctions'} onClick={() => onChange('auctions')}>Auctions</Tab>
    )}
    <Tab $active={view === 'system'} onClick={() => onChange('system')}>System</Tab>
    <Tab $active={view === 'faq'} onClick={() => onChange('faq')}>FAQ</Tab>
    <Tab $active={view === 'contracts'} onClick={() => onChange('contracts')}>Contracts</Tab>
  </Bar>
);

export default LandingTabs;
